<template>
  <div class="stickerSettingsPanel">
    <div class="settingsTitle">
      {{ $t('recorderDrawer.settings') }}
    </div>

    <div class="settingsContent" data-test="recorderSettingButton">
      <RecordIOSettings/>

      <div class="subSectionTitle">{{ $t('settings.panel.titleSectionTime') }}</div>
      <RecordSectionSettings/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import RecordIOSettings from '@/components/recorder/setup/RecordIOSettings.vue';
import RecordSectionSettings from '@/components/recorder/setup/RecordSectionSettings.vue';

@Component({
  components: {
    RecordIOSettings,
    RecordSectionSettings,
  },
})
export default class RecorderStickerSettingsPanel extends Vue {
}
</script>

<style scoped lang="scss">
.stickerSettingsPanel {
  width: 100%;

  .settingsTitle {
    font-size: 20px;
    color: var(--black);
    font-weight: 900;
    padding-left: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .settingsContent {
    padding: 0 8px 16px 8px;

    .subSectionTitle {
      margin-top: 24px;
      font-size: 14px;
      font-weight: 900;
      color: var(--black);
      border-top: solid 1px var(--light);
      padding-top: 16px;
    }
  }
}
</style>
